import React from 'react';
import UsaOnly from 'common/components/UsaOnly';
import CanadaOnly from 'common/components/CanadaOnly';
import ExpandableTableRowInfo from 'common/oldJavascripts/components/Base/ExpandableTable/ExpandableTableRowInfo';
import ExpandableTableRowHeader from 'common/oldJavascripts/components/Base/ExpandableTable/ExpandableTableRowHeader';
import ExpandableTableRow from 'common/oldJavascripts/components/Base/ExpandableTable/ExpandableTableRow';
import ExpandableTableCell from 'common/oldJavascripts/components/Base/ExpandableTable/ExpandableTableCell';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  optOutText: {
    marginLeft: '20px',
  },
  customOccupationDescriptionText: {
    marginLeft: '8px',
  },
  termsOfHireText: {
    marginLeft: '10px',
    marginBottom: '20px',
    display: 'flex',
  },
  termsOfHireSubHeader: {
    fontWeight: 600,
    marginRight: '5px',
  },
  noDeptText: {
    fontStyle: 'italic',
  },
  offerDocuments: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '-10px',
  },
  docCount: {
    marginTop: '-7px',
  },
  termsOfHireTable: {
    display: 'Flex',
  },
  termsOfHireTextUsaRightInfo: { width: '50%' },
  termsOfHireTextCanadaRightInfo: { width: '50%' },
  termsOfHireTextUsaLeftInfo: { width: '50%' },
  termsOfHireTextCanadaLeftInfo: { width: '50%' },
}));

const TermsOfHire = ({ offer }) => {
  const classes = useStyles();
  const {
    id,
    hire_city,
    hire_state,
    work_state,
    work_city,
    hiring_status,
    type = '',
    union,
    occupation,
    work_schedule,
    department_name = '',
    custom_occupation_description = null,
    associated_hours_plus_department = '',
    season = null,
    currency = null,
  } = offer;
  const hireCityName = hire_city?.name;
  const hireStateName = hire_state?.name;
  const workStateName = work_state?.name;
  const workCityName = work_city?.name;
  const { description: unionName } = union;
  const { description: occupationName } = occupation;
  const { description: workScheduleDescription } = work_schedule;

  const formatEmploymentClassification =
    type && type === 'loanOut' ? 'Loan-out' : type;

  const formatEmploymentClassificationCAN =
    type && type === 'loanOut' ? 'Loan-out' : 'Individual';

  return (
    <>
      <ExpandableTableRow key={`terms-of-hire-${id}`} rowExpanded={true}>
        <ExpandableTableCell colSpan={10} expanded={true}>
          <ExpandableTableRowHeader>Terms of Hire</ExpandableTableRowHeader>
          <UsaOnly>
            <div className={classes.termsOfHireTable}>
              <div className={classes.termsOfHireTextUsaLeftInfo}>
                <ExpandableTableRowInfo>
                  {!(season === null) && (
                    <div className={classes.termsOfHireText}>
                      <p className={classes.termsOfHireSubHeader}>Season:</p>
                      <p>{season?.label}</p>
                    </div>
                  )}
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Hire State:{''}
                    </p>
                    <p>{hireStateName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Hire City:{''}
                    </p>
                    <p>{hireCityName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Work State:{''}
                    </p>
                    <p>{workStateName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Primary Work City:{' '}
                    </p>
                    <p>{workCityName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      ACA Hiring Status:{' '}
                    </p>
                    <p>
                      {hiring_status === 'full_time'
                        ? 'Full Time'
                        : hiring_status}
                    </p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Employment Classification:{' '}
                    </p>
                    <p>{formatEmploymentClassification}</p>
                  </div>
                </ExpandableTableRowInfo>
              </div>
              <div className={classes.termsOfHireTextUsaRightInfo}>
                <ExpandableTableRowInfo>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>Union:</p>
                    <p>{unionName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>Occupation:</p>
                    <p>{occupationName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Work Schedule:{' '}
                    </p>
                    <p>{workScheduleDescription}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>Department:</p>
                    <p>{department_name}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Associated Hours+ Department:{' '}
                    </p>
                    <p
                      className={`${
                        associated_hours_plus_department
                          ? ''
                          : classes.noDeptText
                      }`}
                    >
                      {associated_hours_plus_department
                        ? associated_hours_plus_department
                        : 'Not Selected'}
                    </p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Job Description:
                    </p>
                    <p>{custom_occupation_description}</p>
                  </div>
                </ExpandableTableRowInfo>
              </div>
            </div>
          </UsaOnly>
          <CanadaOnly>
            <div className={classes.termsOfHireTable}>
              <div className={classes.termsOfHireTextCanadaLeftInfo}>
                <ExpandableTableRowInfo>
                  {!(season === null) && (
                    <div className={classes.termsOfHireText}>
                      <p className={classes.termsOfHireSubHeader}>Season:</p>
                      <p>{season?.label}</p>
                    </div>
                  )}
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Hire Province:{' '}
                    </p>
                    <p>{hireStateName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Work Province:{' '}
                    </p>
                    <p>{workStateName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>Currency: </p>
                    <p>{currency}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Employment Classification:{' '}
                    </p>
                    <p>{formatEmploymentClassificationCAN}</p>
                  </div>
                </ExpandableTableRowInfo>
              </div>
              <div className={classes.termsOfHireTextCanadaRightInfo}>
                <ExpandableTableRowInfo>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>Union:</p>
                    <p>{unionName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>Occupation:</p>
                    <p>{occupationName}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Work Schedule:{' '}
                    </p>
                    <p>{workScheduleDescription}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>Department:</p>
                    <p>{department_name}</p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Associated Hours+ Department:{' '}
                    </p>
                    <p
                      className={`${
                        associated_hours_plus_department
                          ? ''
                          : classes.noDeptText
                      }`}
                    >
                      {associated_hours_plus_department
                        ? associated_hours_plus_department
                        : 'Not Selected'}
                    </p>
                  </div>
                  <div className={classes.termsOfHireText}>
                    <p className={classes.termsOfHireSubHeader}>
                      Job Description:
                    </p>
                    <p>{custom_occupation_description}</p>
                  </div>
                </ExpandableTableRowInfo>
              </div>
            </div>
          </CanadaOnly>
        </ExpandableTableCell>
      </ExpandableTableRow>
    </>
  );
};

export default TermsOfHire;
